import { render, staticRenderFns } from "./genUser.vue?vue&type=template&id=0de5347e&scoped=true&"
import script from "./genUser.vue?vue&type=script&lang=js&"
export * from "./genUser.vue?vue&type=script&lang=js&"
import style0 from "./genUser.vue?vue&type=style&index=0&id=0de5347e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de5347e",
  null
  
)

export default component.exports